import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { CartService, CartServiceModule } from '@b2b/common/services/cart';
import { getFullName } from '@b2b/common/services/helpers';
import { TODO, UIBModalService } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IQService, IScope } from 'angular';

interface SelectedCardholder {
  id: TODO;
  cardExpirationDate: TODO;
  customerId: TODO;
  membershipCategory: TODO;
  membershipId: TODO;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

interface OrderContactModel {
  cardId: number;
  customerId: number;
  membership: TODO;
  name?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
}

OrderContactDirective.$inject = ['$state', '$filter', 'AddressService', 'ApiService', 'HelpersService', 'CartService'];

function OrderContactDirective(
  $state: StateService,
  $filter: IFilterService,
  AddressService: AddressService,
  ApiService: TODO,
  HelpersService: TODO,
  CartService: CartService,
) {
  OrderContactController.$inject = ['$scope', '$uibModal', '$q'];

  function OrderContactController($scope: IScope & { orderContact: TODO }, $uibModal: UIBModalService, $q: IQService) {
    const ctrl = {
      model: {} as Partial<OrderContactModel>,
      address: {},
      selectedCardholder: null as SelectedCardholder | null,
      membersList: [] as TODO[],

      isLoaded: false,

      waitTime: 500,

      init: function () {
        $scope.$on('$destroy', $scope.$watch('orderContact.model', ctrl.onModelUpdate));
      },

      searchMembers: function (searchText = '') {
        const props = HelpersService.getPaginator();

        if (!searchText && !ctrl.isLoaded) {
          ctrl.resetSelection();
          ctrl.isLoaded = true;
        } else {
          props.search = searchText;
          props.pageSize = 8;
          ApiService.membership.summaries.search(props).then(ctrl.success.searchMembers, ctrl.error.searchMembers);
        }
      },

      isExpiredMembership: function () {
        // TODO Determine which cardholder to take
        if (ctrl.model) {
          return CartService.memberships.isMembershipExpired(ctrl.model.membership);
        }
        return false;
      },

      rejoin: function () {
        let props;

        if (ctrl.model && ctrl.model.membership) {
          props = {
            membershipId: ctrl.model.membership.id,
            orderContactId: ctrl.model.customerId,
          };
          if (props.membershipId) {
            $state.go('application.membership.retail', props);
            $scope.$emit('Cart::Close');
          }
        }
      },

      resetSelection: function (force = false) {
        if (force || ctrl.model.cardId) {
          ctrl.membersList = ctrl.processMembersList([ctrl.model]);
          ctrl.selectedCardholder = ctrl.membersList[0];
        } else {
          ctrl.membersList = [];
          ctrl.selectedCardholder = null;
        }
      },

      processMembersList: function (list) {
        //set name property

        if (!ctrl.isLoaded && !ctrl.membersList.length) {
          //show only the current orderContact
          list = list.filter(function (member) {
            let result = true;
            if (ctrl.model.cardId) {
              result = ctrl.model.cardId === member.id || ctrl.model.cardId === member.cardId;
            }
            return result;
          });
        } else {
          // don't show any members that have pending memberships
          list = list.filter(function (member) {
            return member.membershipStanding && member.membershipStanding !== 'new';
          });
        }
        angular.forEach(list, function (member) {
          if (!member.name) {
            member.name = getFullName(member);
          }
          if (!member.membership) {
            member.membership = {
              membershipExpirationDate: member.membershipExpirationDate,
              membershipStanding: member.membershipStanding,
              acmeMembershipNumber: member.acmeMembershipNumber,
              membershipCategory: member.membershipCategory,
            };
            member.membership = CartService.processMembership(member.membership);
          }
        });
        return list;
      },

      updateOrderContact: function () {
        const isNewMembership = CartService.memberships.hasNewMembership();
        const showPrompt =
          isNewMembership ||
          (CartService.hasOrderContact() && !CartService.isOrderContact(ctrl.selectedCardholder?.customerId));
        const isNewCardholder = ctrl.model.cardId && ctrl.model.cardId !== ctrl.selectedCardholder?.id;
        let message;
        let title = 'Are you sure?';

        if (showPrompt) {
          if (!ctrl.selectedCardholder) {
            message =
              'Do you want to remove ' +
              getFullName(CartService.getOrderContact()) +
              ' from the order?' +
              '<br><br>Doing so will remove any items in the cart.';
          } else if (!ctrl.selectedCardholder.customerId) {
            message =
              'Do you want to change the transacting member from ' +
              getFullName(CartService.getOrderContact()) +
              ' ?' +
              '<br><br>Doing so will remove any items in the cart.';
          } else {
            if (isNewMembership) {
              title = 'Proceeding will clear the cart';
              message =
                getFullName(ctrl.selectedCardholder) +
                ' already has a membership: ' +
                ctrl.selectedCardholder.membershipCategory +
                ' (expiring ' +
                $filter('date')(ctrl.selectedCardholder.cardExpirationDate, HelpersService.dateFormats.shortDate) +
                ').' +
                ' Adding a member to this cart will clear the contents.';
            } else {
              message =
                'Do you want to transact as ' +
                getFullName(ctrl.selectedCardholder) +
                ' instead of ' +
                getFullName(CartService.getOrderContact()) +
                '? ' +
                '<br><br>Doing so will remove any items in the cart.';
            }
          }

          ctrl
            .showMessage({ title, message, okText: 'Continue' })
            .then(() => {
              ctrl.updateContactAndProceed(isNewMembership);
            })
            .catch(() => {
              if (ctrl.model) {
                ctrl.selectedCardholder = getFullName(ctrl.model) as TODO;
              } else if (!ctrl.selectedCardholder) {
                ctrl.resetSelection();
              }
            });
        } else if (isNewCardholder) {
          //same customer but different membership
          message =
            'Do you want to transact as ' +
            ctrl.selectedCardholder?.membershipCategory +
            ' instead of ' +
            CartService.getTransactingMembership().membershipCategory +
            '?' +
            '<br><br>Doing so will remove any items in the cart.';

          ctrl
            .showMessage({ title: 'Are you sure?', message, okText: 'Continue' })
            .then(() => {
              ctrl.updateContactAndProceed();
            })
            .catch(() => {
              if (ctrl.model) {
                ctrl.selectedCardholder = getFullName(ctrl.model) as TODO;
              } else if (!ctrl.selectedCardholder) {
                ctrl.resetSelection();
              }
            });
        } else {
          ctrl.updateContactAndProceed();
        }
      },

      updateContactAndProceed: function (clearCart = false) {
        const contact = ctrl.selectedCardholder
          ? {
              membershipId: ctrl.selectedCardholder.membershipId,
              cardholders: ctrl.selectedCardholder.customerId ? [ctrl.selectedCardholder] : null,
              orderContactId: ctrl.selectedCardholder.customerId,
            }
          : null;

        const promise = clearCart ? CartService.cancelCart() : $q.resolve();

        return promise
          .then(() => CartService.memberships.updateOrderContact(contact).then(() => ctrl.success.updateOrderContact()))
          .catch(() => ctrl.error.updateOrderContact());
      },

      showMessage: function (props: { title: string; message: string; okText: string }) {
        if (!props.message) {
          return Promise.resolve();
        }

        return $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: () => props.title,
            modalMessage: () => props.message,
            okText: () => props.okText || 'Done',
            cancelText: () => null,
          },
        }).result;
      },

      success: {
        searchMembers: function (response) {
          ctrl.membersList = ctrl.processMembersList(response.data.payload.list);
          if (!ctrl.isLoaded) {
            ctrl.selectedCardholder = ctrl.membersList[0];
          }
          $scope.$broadcast('CustomTypeahead::FilterResults', {
            field: 'combobox-input-' + 'order-contact-membership-search',
          });

          ctrl.isLoaded = true;
        },

        updateOrderContact: function () {
          if (!ctrl.selectedCardholder) {
            ctrl.resetSelection(true);
          }
          //Refresh the cart so that items are updated
          $scope.$emit('Cart::Refresh');
        },
      },

      error: {
        searchMembers: function () {
          ctrl.membersList = [];
          ctrl.isLoaded = true;
        },

        updateOrderContact: function () {
          if (!ctrl.selectedCardholder) {
            ctrl.resetSelection();
          }
        },
      },

      onCardholderChange: function (e, data) {
        ctrl.updateOrderContact();
      },

      onBlur: function () {
        ctrl.resetSelection();
      },

      onModelUpdate: function (n, o) {
        if (HelpersService.isEmptyObject(n)) {
          ctrl.selectedCardholder = null;
        } else {
          ctrl.selectedCardholder = getFullName(n) as TODO;
        }
        if (!ctrl.membersList.length) {
          ctrl.searchMembers();
        }
      },
    };

    $scope.orderContact = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    require: 'ngModel',
    templateUrl: 'common/directives/order/contact/contact.tpl.html',

    link: function ($scope, $element, $attrs, ngModelCtrl) {
      // Modified after controller runs
      ngModelCtrl.$formatters.push(function (modelValue) {
        return modelValue ? { model: modelValue || {} } : { model: {} };
      });

      ngModelCtrl.$render = function () {
        $scope.orderContact.model = ngModelCtrl.$viewValue.model;
        if (!HelpersService.isEmptyObject($scope.orderContact.model)) {
          $scope.orderContact.model.address = AddressService.createAddress(ngModelCtrl.$viewValue.model);
        }
      };
    },

    controller: OrderContactController,
  };
}

export const OrderContactDirectiveModule = angular
  .module('acme.common.directive.order.contact', [
    AddressServiceModule,
    'acme.common.service.api',
    'acme.common.service.helpers',
    CartServiceModule,
    'acme.common.directive.contactSearch',
    'ui.bootstrap',
  ])
  .directive('orderContact', OrderContactDirective).name;
